// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".service-cms-content[data-v-67d5b09f]{padding:30px;margin-top:16px;border-radius:20px;box-sizing:border-box;background:hsla(var(--white-section)/1);border:1px solid hsla(var(--black-section)/.1)}@media(max-width:1359px){.service-cms-content[data-v-67d5b09f]{padding:20px;border-radius:10px}}@media(max-width:639px){.service-cms-content[data-v-67d5b09f]{padding:12px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
